/**
 * Utility to detect and handle subdomain-based routing
 */

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Handle localhost and IP addresses (no subdomain)
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  // Split hostname into parts
  const parts = hostname.split('.');
  
  // If we have at least 3 parts (subdomain.domain.tld), extract subdomain
  if (parts.length >= 3) {
    return parts[0];
  }
  
  return null;
};

export const isCardsSubdomain = () => {
  const subdomain = getSubdomain();
  return subdomain === 'cards';
};

export const isAdminSubdomain = () => {
  const subdomain = getSubdomain();
  return subdomain === 'admin' || subdomain === null; // Default to admin for localhost
};

export const getFullDomain = () => {
  return window.location.hostname;
};
